import { listPromotions, createPromotion, updatePromotion, deletePromotion } from '@/services/academy/promotions.service'

export default {
	namespaced: true,
	state: {
		list:       { data: [], meta: { total: 0 } },
		listStatus: 'init',
	},
	getters: {
		getList:       (s) => s.list,
		getListStatus: (s) => s.listStatus,
	},
	mutations: {
		SET_LIST(state, v)        { state.list = v },
		SET_LIST_STATUS(state, v) { state.listStatus = v },
	},
	actions: {
		async fetchList({ commit }, params) {
			commit('SET_LIST_STATUS', 'pending')
			try {
				const { data } = await listPromotions(params)
				commit('SET_LIST', data)
				commit('SET_LIST_STATUS', 'init')
			} catch {
				commit('SET_LIST_STATUS', 'error')
			}
		},
		async create({ dispatch }, data) {
			await createPromotion(data)
			dispatch('fetchList')
		},
		async update({ dispatch }, data) {
			await updatePromotion(data)
			dispatch('fetchList')
		},
		async remove({ dispatch }, id) {
			await deletePromotion(id)
			dispatch('fetchList')
		},
	},
}
